import { makeObservable, observable, action } from 'mobx';

var GameResultStore = /** @class */ (function () {
    function GameResultStore() {
        this.gameResults = [];
        this.additionalResults = [];
        makeObservable(this, {
            gameResults: observable.deep,
            additionalResults: observable.deep,
            setGameResults: action.bound,
            setAdditionalResults: action.bound,
        });
    }
    GameResultStore.prototype.setGameResults = function (gameResults) {
        this.gameResults = gameResults;
    };
    GameResultStore.prototype.setAdditionalResults = function (additionalResults) {
        this.additionalResults = additionalResults;
    };
    return GameResultStore;
}());
var gameResultStore = new GameResultStore();

export { GameResultStore, gameResultStore };
